"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    logs: {
        path: "/logs"
    },
    createLog: {
        path: "/logs/create/:propertyId"
    },
    editLog: {
        path: "/logs/:id"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvbG9ncy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGxvZ3M6IHtcbiAgICBwYXRoOiBcIi9sb2dzXCIsXG4gIH0sXG4gIGNyZWF0ZUxvZzoge1xuICAgIHBhdGg6IFwiL2xvZ3MvY3JlYXRlLzpwcm9wZXJ0eUlkXCIsXG4gIH0sXG4gIGVkaXRMb2c6IHtcbiAgICBwYXRoOiBcIi9sb2dzLzppZFwiLFxuICB9LFxufSk7XG4iXSwibmFtZXMiOlsicm91dGVzIiwiYnVpbGRSb3V0ZXMiLCJsb2dzIiwicGF0aCIsImNyZWF0ZUxvZyIsImVkaXRMb2ciXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxNQUFNO1FBQ0pDLE1BQU07SUFDUjtJQUNBQyxXQUFXO1FBQ1RELE1BQU07SUFDUjtJQUNBRSxTQUFTO1FBQ1BGLE1BQU07SUFDUjtBQUNGIn0=